import moment from 'moment';

/**
 * Map of fields to be non-falsey for effective date screen to be skipped per line of business.
 */
var requiredFieldsByLOBMap = {
    commercialProperty: ['accountOrgType'],
    businessOwners: ['accountOrgType', 'smallBusinessType']
};

export default function (subFlows, branchOnProductCodeFn, TranslateService, LoadSaveService, ViewModelService, ViewModelCtx) {

    function isEffectiveDateInTheFuture(periodStartDate) {
        var currentTime = moment().startOf('day');
        return moment(periodStartDate).isAfter(currentTime, 'day');
    }

    var ACTIONS = {
        saveDraftSubmission: function saveDraftSubmission(_ref) {
            var submission = _ref.value;
            return LoadSaveService.saveSubmission(submission).then(function (submissionDTO) {
                return ViewModelService.create(submissionDTO, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO', ViewModelCtx);
            });
        }
    };

    var ACTION_MSGS = {
        saveSubmission: {
            error: {
                title: 'quoteandbind.common.config.FlowConfig.Unable to save submission',
                message: 'quoteandbind.common.config.FlowConfig.An error occurred while attempting to save quote submission.'
            },
            progress: {
                message: 'quoteandbind.common.config.FlowConfig.Saving quote...'
            }
        }
    };

    return function (step) {

        step('effectiveDate', true).skipOnResumeIf(function (_ref2) {
            var submission = _ref2.value;

            //If the coverage start date is past date then the user is routed to 'Policy Details' screen to validate again._MSF
            if (submission.baseData.periodStartDate && !isEffectiveDateInTheFuture(submission.baseData.periodStartDate)) {
                console.log("Period Start Date Is Past Date");
                return false;
            }

            /* return !Object.keys(requiredFieldsByLOBMap).some(lob => {
                 const lobData = submission.lobData[lob];
                 if (!lobData) {
                     return false;
                 }
                   const requiredProperties = requiredFieldsByLOBMap[lob];
                 return requiredProperties.some(prop => !lobData[prop]);
             });*/
            if (submission.baseData.mSFGroups_EXT == undefined || submission.baseData.busOpsDesc == undefined) {
                return false;
            } else if (submission.baseData.isMSFMTConstrOpEngaged) {
                if (submission.baseData.mSFConstructionDate == undefined) return false;
            } else {
                return true;
            }
        }).onNext.doAction(ACTIONS.saveDraftSubmission, ACTION_MSGS.saveSubmission).thenBranch(branchOnProductCodeFn(subFlows.paFlows, subFlows.hoFlows, subFlows.cpFlows, subFlows.bopFlows, subFlows.wcFlows, 'coverables')).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return TranslateService.instant('quoteandbind.wizard.step.Policy Details');
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/gateway/quoteandbind/config/_flowBegining.js
// module id = 2217
// module chunks = 0